// extracted by mini-css-extract-plugin
module.exports = {"successMesage":"_2nyCWzENS74Ec5BUx2RuN8","subscribeButton":"_3sNdKfaPd1KdZU8eAjSNA","validation":"_3wBQsVFcnWggFbG_gOOU9d"};